// extracted by mini-css-extract-plugin
export var cardFadeIn = "styles-module--card-fadeIn--73513";
export var cmtSNews__card = "styles-module--cmt-s-news__card--88ec8";
export var cmtSNews__loadMore = "styles-module--cmt-s-news__load-more--b5004";
export var cmtSNews__loadMoreContainer = "styles-module--cmt-s-news__load-more-container--43294";
export var cmtSNews__loadMoreIcon = "styles-module--cmt-s-news__load-more-icon--5b11b";
export var cmtSNews__loadMoreIconLoading = "styles-module--cmt-s-news__load-more-icon--loading--05360";
export var cmtSNews__loadMoreText = "styles-module--cmt-s-news__load-more-text--eadcd";
export var cmtSNews__loadMoreWrapper = "styles-module--cmt-s-news__load-more-wrapper--66b74";